import React from 'react';

const Right = ({ width, height, color }) => (
    <svg
        width={width || '5'}
        height={height || '8'}
        viewBox='0 0 5 8'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M0 0L5 4L0 8V0Z' fill={color || '#F4F4F4'} />
    </svg>
);

export default Right;
